module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Throughout the years I have frequently been occupied with Romans. I have worked with it extensively while writing books on theology (especially on the cross). I have lectured on it many times, and am indebted to students in Britain, Canada, the United States, and Australia for their interaction. But prior to this I have never written at length on Romans. Now in my retirement I have finally had the opportunity to devote time to a commentary on this great epistle. I offer it as my tribute to an apostle to whom I owe so much.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I have included the text of the New International Version as an aid to the reader. Occasionally I have made my own translation (without specifically drawing attention to it) in order to bring out some feature of the original. But the commentary is based on the Greek text, not the translation. It has been my aim to make clear to the general reader what I see in the Greek text, and it is my hope that this will be of some help to others who are grappling with the thought of this great epistle.")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("LEON MORRIS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb5394dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Preface.vue
// module id = 72
// module chunks = 0